"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormWrapper = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const Logo_1 = require("../../molecules/utils/Logo");
const FormWrapper = ({ className, children, logoText, showLogo = true, logoSVG }) => {
    return ((0, jsx_runtime_1.jsxs)(Container, { className: className, children: [showLogo && ((0, jsx_runtime_1.jsx)("div", { "data-svg": "logo-wrapper", children: (0, jsx_runtime_1.jsx)(Logo_1.Logo, { text: logoText, logoSVG: logoSVG }, void 0) }, void 0)), (0, jsx_runtime_1.jsx)(Center, { children: children }, void 0)] }, void 0));
};
exports.FormWrapper = FormWrapper;
const Container = styled_components_1.default.div `
  display: grid;
  grid-template-rows: 1fr min-content;
  grid-template-columns: 1fr;
  justify-items: center;
  width: 100%;

  & > [data-svg="logo-wrapper"] {
    margin-bottom: 4.25rem;

    & img[data-svg="logo"] {
      height: 2.375rem;
      width: auto;
    }
  }

  @media (min-width: ${({ theme }) => theme.utils.breakpoints.mobile}) {
    & [data-svg="logo-wrapper"] {
      display: none;
    }
  }
`;
const Center = styled_components_1.default.div `
  align-items: center;
  display: flex;
  justify-content: center;
  width: 100%;
`;
//# sourceMappingURL=FormWrapper.js.map